import React, { useContext } from 'react';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { DebounceInput } from 'react-debounce-input';

import EkovillaContext from '../contexts/EkovillaContext';

function CompetitorRow(props) {

    const { handleStateChange } = useContext(EkovillaContext);

    return (
        <Tr className="even:bg-white odd:bg-green-200">
            <Td className="p-1 whitespace-no-wrap text-sm xl:text-base">{props.row.comPart}</Td>
            <Td className="text-center text-sm xl:text-base"><DebounceInput className="w-20 border-solid border border-gray-600 rounded pl-1"
                debounceTimeout={500} name="comArea" type="number" min="0" onChange={(e) => { handleStateChange(e, props.index) }}></DebounceInput>
            </Td>
            <Td className="text-center text-sm xl:text-base"><DebounceInput className="w-20 border-solid border border-gray-600 rounded pl-1"
                debounceTimeout={500} name="comThickness" type="number" min="0" onChange={(e) => { handleStateChange(e, props.index) }}></DebounceInput>
            </Td>
            <Td className="text-center text-sm xl:text-base"><label>{(props.row.comInsulationCubic)}</label></Td>
            <Td className="text-center text-sm xl:text-base"><DebounceInput className="w-20 border-solid border border-gray-600 rounded pl-1"
                debounceTimeout={500} name="comInsulationThicknessCubic" type="number" min="0" onChange={(e) => { handleStateChange(e, props.index) }}></DebounceInput>
            </Td>
            <Td className="text-center text-sm xl:text-base"><DebounceInput className="w-20 border-solid border border-gray-600 rounded pl-1"
                debounceTimeout={500} name="comCarbonFoot" type="number" min="0" onChange={(e) => { handleStateChange(e, props.index) }}></DebounceInput>
            </Td>
            <Td className="text-center text-sm xl:text-base"><DebounceInput className="w-20 border-solid border border-gray-600 rounded pl-1"
                debounceTimeout={500} name="comCarbonHand" type="number" min="0" onChange={(e) => { handleStateChange(e, props.index) }}></DebounceInput>
            </Td>
        </Tr>
    )
}

export default CompetitorRow;